import React from "react";
import "./gridSemaforo.css";
import { Grid, useMediaQuery } from "@material-ui/core";

const months = [
    { name: "Ene", number: 1 },
    { name: "Feb", number: 2 },
    { name: "Mar", number: 3 },
    { name: "Abr", number: 4 },
    { name: "May", number: 5 },
    { name: "Jun", number: 6 },
    { name: "Jul", number: 7 },
    { name: "Ago", number: 8 },
    { name: "Sept", number: 9 },
    { name: "Oct", number: 10 },
    { name: "Nov", number: 11 },
    { name: "Dic", number: 12 }
];

const MesesHeader = (props) => {
    return (
        <div className="monthHeader">
            {months.map((mes) => (
                <div className={`monthItem ${props.onMonthSelected ? "monthItem-btn" : ""}`} key={mes.name} onClick={() => props?.onMonthSelected(true, mes.number, mes.name)}>
                    <p>{mes.name}</p>
                </div>
            ))}
        </div>
    );
};

const Semaforo = (props) => {
    const { dataItem, getColorByStatus, statusFieldName, onClick, isUpload, yearShown } = props;

    const compliance = dataItem.compliance ? dataItem.compliance : [];

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const showHeader = useMediaQuery("(max-width:960px)");

    return (
        <>
            {showHeader && <MesesHeader onMonthSelected={props?.onMonthSelected} />}
            <div className='semaforo-container'>
                {
                    months.map((_, index) => {
                        let isFutureMonth = false;
                        let representedMonth = new Date(yearShown, index, 1);
                        if (representedMonth >= firstDayOfMonth) {
                            isFutureMonth = true;
                        }

                        let complianceIndex = compliance.findIndex(elem => elem.month - 1 == index);
                        let color = "";

                        if (complianceIndex != -1) {
                            let status = statusFieldName
                                ? compliance[complianceIndex][statusFieldName]
                                : compliance[complianceIndex].status;
                            color = getColorByStatus(status);
                        }

                        if (!isFutureMonth && color == "") {
                            color = "red";
                        }

                        if (isFutureMonth && color == "red") {
                            color = "";
                        }

                        let circleDisplayed = <div className={`semaforo-circle ${color}`}></div>;

                        if (onClick) {
                            if (isUpload && color != "green") {
                                // Upload document button
                                circleDisplayed = (
                                    <button
                                        className={`semaforo-circle ${color}`}
                                        onClick={() => onClick(dataItem, index)}
                                    />
                                );
                            }
                            if (!isUpload && (color == "green" || color == "yellow")) {
                                // View details button
                                circleDisplayed = (
                                    <button
                                        className={`semaforo-circle ${color}`}
                                        onClick={() => onClick(compliance[complianceIndex])}
                                    />
                                );
                            }
                        }

                        return (
                            <div className='semaforo-item' key={index}>
                                {circleDisplayed}
                            </div>
                        )
                    })
                }
            </div >
        </>
    );
};

function GridSemaforoPure(props) {
    const {
        columnTitle,
        dataItems,
        onButtonClick,
        buttonTitle,
        getColorByStatus,
        statusFieldName,
        onSemaforoClick,
        isUpload,
        yearShown,
    } = props;
    const showHeader = useMediaQuery("(min-width:960px)");

    const firstColumnSpanLg = buttonTitle ? 3 : 5;
    const firstColumnSpanSm = buttonTitle ? 8 : 12;

    return (
        <Grid
            container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="gridSemaforo"
        >
            {/* HEADER */}
            {showHeader &&
                <Grid
                    container
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className="gridSemaforo-headerContainer"
                >
                    <Grid item
                        xs={5}
                        lg={5}
                        md={5}
                        sm={5}
                        es={5}
                        className="gridSemaforo-headerColumn"
                    >
                        <p className='column-title'>{columnTitle}</p>
                    </Grid>
                    <Grid item
                        xs={7}
                        lg={7}
                        md={7}
                        sm={7}
                        es={7}
                        className="gridSemaforo-headerColumn"
                    >
                        <p className='column-title cumplimiento'>Cumplimiento</p>
                        <MesesHeader onMonthSelected={props?.onMonthSelected} />
                    </Grid>
                </Grid>
            }
            {/* BODY */}
            {
                (!dataItems || dataItems.length === 0) && <p style={{ margin: "auto" }}>No hay datos</p>
            }
            {
                dataItems && dataItems.length > 0 &&
                dataItems.map((dataItem) =>
                    <Grid container className='gridSemaforo-item' key={dataItem.name}>
                        <Grid item
                            lg={firstColumnSpanLg}
                            md={firstColumnSpanLg}
                            sm={firstColumnSpanSm}
                            xs={firstColumnSpanSm}
                            es={firstColumnSpanLg}
                        >
                            <p className='name'>
                                {dataItem.name}
                            </p>
                        </Grid>
                        {buttonTitle &&
                            <Grid item
                                lg={2}
                                md={2}
                                sm={4}
                                xs={4}
                                es={2}
                            >
                                <button
                                    className='view-button'
                                    onClick={() => onButtonClick(dataItem)}
                                >
                                    {buttonTitle}
                                </button>
                            </Grid>
                        }
                        <Grid item
                            lg={7}
                            md={7}
                            sm={12}
                            xs={12}
                            es={7}
                        >
                            <Semaforo
                                dataItem={dataItem}
                                getColorByStatus={getColorByStatus}
                                statusFieldName={statusFieldName}
                                onClick={onSemaforoClick}
                                isUpload={isUpload}
                                yearShown={yearShown}
                                onMonthSelected={props?.onMonthSelected}
                            />
                        </Grid>
                    </Grid>
                )
            }
        </Grid >
    );
}

export default GridSemaforoPure;
